/* The content measure — one string, so the bar and the page underneath it can
 * never drift apart.
 *
 * WIDE_MEASURE is the Company Profile bound introduced for TIP-644's visual
 * review: capped at 1536, and below the cap it tracks the viewport with a 24px
 * gutter so the cards never touch the glass. `min()` rather than a flat cap
 * plus padding because the side gutter on web was deliberately removed from
 * that screen — this keeps the look and still guarantees the gap.
 *
 * The whole thing is gated behind `sm:` on purpose. `min(…, 100% - 3rem)` binds
 * at EVERY width, so unprefixed it also took 24px off each side of a phone —
 * on top of the `px-4` already there, which put the cards 40px in instead of
 * 16px and squeezed the header row with them. The 3rem gutter exists to stop
 * the cards touching the glass below the cap on a desktop; on a phone `px-4` is
 * already doing that job, so below sm this is a plain full-width box with 16px
 * of page padding — exactly what the screen had before the cap was introduced.
 *
 * The padding is part of the measure, not a caller's decision. Anything that
 * wants to line up with the profile content must use this exact string,
 * including the padding — a caller that re-implements it is how the header fell
 * 128px inside the cards in the first place.
 *
 * Now the measure for every uplifted public screen: PageContainer, the u1
 * Navbar, the home sections' `.container-wide` and the public Header all read
 * it. The LEGACY public pages (Terms, Privacy, Thank You, the GPT prompt
 * screens) and the dashboard shell are deliberately untouched — they keep the
 * 1280 bound below.
 */
export const WIDE_MEASURE =
  "mx-auto w-full px-4 sm:max-w-[min(1536px,100%-3rem)] sm:px-0";

/* The bound the un-uplifted public screens still use: 1280, with the horizontal
   padding living on the bar/page rather than in the measure. */
export const BASE_MEASURE = "mx-auto max-w-7xl";

/* Which routes under the shared public shell are uplifted. */
export const WIDE_ROUTES = ["/", "/search", "/order-web-profile"];

export const isWideRoute = (pathname = "") => {
  /* A trailing slash is the same route; "/" itself must survive the trim. */
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;
  if (WIDE_ROUTES.includes(path)) return true;
  /* /search/:id — the company profile. Not /search/:id/anything, and not
     /gpt-prompts/search/:id, which only ends in the same shape. */
  return /^\/search\/[^/]+$/.test(path);
};

export default WIDE_MEASURE;
